export default __webpack_public_path__ + "static/media/cny-flower-1.852574c0.webp";